<template>
  <b-button v-if="!hasPermission" v-b-tooltip.hover :title="noPermissionMessage" :variant="variant" :size="size" :class="`${buttonClass} inner-disabled`">
    <slot name="button-content" />
  </b-button>
  <b-button v-else-if="showTooltip" v-b-tooltip.hover :title="title" :variant="variant" :size="size" :disabled="disabled" :class="buttonClass" @click="clickButton">
    <slot name="button-content" />
  </b-button>
  <b-button v-else v-b-tooltip.hover :title="title" :variant="variant" :size="size" :disabled="disabled" :class="buttonClass" @click="clickButton">
    <slot name="button-content" />
  </b-button>
</template>

<script>
export default {
  props: {
    hasPermission: { type: Boolean, default: true },
    noPermissionMessage: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    variant: { type: String, default: null, required: true },
    size: { type: String, default: 'md' },
    buttonClass: { type: String, default: null },
    title: { type: String, default: null },
    showTooltip: { type: Boolean, default: false },
  },
  methods: {
    clickButton() {
      this.$emit('click')
    }
  }
}
</script>